import {
  Dashboard as DashboardIcon,
  Inventory as InventoryIcon,
  People as PeopleIcon,
  ShoppingCart as ShoppingCartIcon,
  Settings as SettingsIcon,
  Category as CategoryIcon,
  Analytics as AnalyticsIcon,
  Payment as PaymentIcon,
  Warehouse as WarehouseIcon,
  Receipt as ReceiptIcon,
  History as HistoryIcon,
  Assignment as AssignmentIcon,
  Webhook as WebhookIcon,
  Add as AddIcon,
  Assessment as AssessmentIcon,
  AccountBalance as AccountBalanceIcon,
  Sell as SellIcon,
  ShoppingBag as PurchaseIcon,
  Group as PartyIcon,
  Undo as ReturnIcon,
  PostAdd as CreateDocIcon,
  Visibility as VisibilityIcon,
  Contacts as ContactsIcon,
  List as ListIcon,
  Upload as UploadIcon,
  Edit as EditIcon,
  FilterList as FilterListIcon,
  Description as ApiDocsIcon,
  Storefront as CustomerPortalIcon,
  Campaign as CampaignIcon,
  HelpOutline as HelpIcon,
  LocalOffer as LocalOfferIcon,
  Instagram as InstagramIcon,
  Redeem as RedeemIcon,
  Hub as HubIcon,
  IntegrationInstructions as IntegrationIcon,
  VpnKey as ApiKeyIcon,
  LocalShipping as ShippingNavIcon,
  Email as EmailIcon,
  Business as CompanyIcon,
  AdminPanelSettings as SecurityIcon,
  Sms as SmsIcon,
} from '@mui/icons-material'
import { MenuItem } from '../types/navigation'

export const getNavigationItems = (): MenuItem[] => [
  // ========== MAIN DASHBOARD ==========
  {
    text: 'Dashboard',
    icon: <DashboardIcon />,
    path: '/admin/dashboard',
    permission: 'dashboard.read'
  },

  // ========== SALES WORKFLOW ==========
  {
    text: 'Sales',
    icon: <SellIcon />,
    requiredPermissions: ['sales_orders.read', 'reports.sales', 'payments.read'],
    children: [
      { text: 'Dashboard', icon: <DashboardIcon />, path: '/admin/sales/dashboard', permission: 'reports.sales' },
      { text: 'Quotations', icon: <AssignmentIcon />, path: '/admin/documents/estimates', permission: 'estimates.read' },
      { text: 'Orders', icon: <ShoppingCartIcon />, path: '/admin/documents/sales-orders', permission: 'sales_orders.read' },
      { text: 'Invoices', icon: <ReceiptIcon />, path: '/admin/documents/invoices', permission: 'invoices.read' },
      { text: 'Payments', icon: <PaymentIcon />, path: '/admin/payments', permission: 'payments.read' },
      { text: 'Shipments', icon: <ShippingNavIcon />, path: '/admin/shipments', permission: 'shipping.read' },
      { text: 'Shipping Help', icon: <HelpIcon />, path: '/admin/help/shipping', permission: 'shipping.read' },
      { text: 'Returns', icon: <ReturnIcon />, path: '/admin/documents/sales-returns', permission: 'sales_returns.read' },
    ],
  },

  // ========== PURCHASE WORKFLOW ==========
  {
    text: 'Purchase',
    icon: <PurchaseIcon />,
    requiredPermissions: ['purchase_orders.read', 'purchase.read'],
    children: [
      { text: 'Dashboard', icon: <DashboardIcon />, path: '/admin/purchase/dashboard', permission: 'purchase.read' },
      { text: 'Purchase Orders', icon: <AssignmentIcon />, path: '/admin/purchase/orders', permission: 'purchase_orders.read' },
      { text: 'Purchase Bills', icon: <ReceiptIcon />, path: '/admin/purchase/bills', permission: 'purchase_bills.read' },
      { text: 'Purchase Returns', icon: <ReturnIcon />, path: '/admin/purchase/returns', permission: 'purchase_returns.read' },
    ],
  },

  // ========== PARTY MANAGEMENT (CUSTOMERS & SUPPLIERS) ==========
  {
    text: 'Parties',
    icon: <PartyIcon />,
    permission: 'customers.read',
    children: [
      { text: 'All Parties', icon: <PartyIcon />, path: '/admin/parties', permission: 'customers.read' },
      { text: 'Customer Groups', icon: <CategoryIcon />, path: '/admin/parties/customer-groups', permission: 'customers.read' },
      { text: 'Ledgers', icon: <AccountBalanceIcon />, path: '/admin/parties/ledgers', permission: 'customers.read' },
    ],
  },

  // ========== PRODUCT CATALOG & INVENTORY ==========
  {
    text: 'Inventory',
    icon: <InventoryIcon />,
    permission: 'products.read',
    children: [
      { text: 'Products', icon: <InventoryIcon />, path: '/admin/products', permission: 'products.read' },
      { text: 'Catalogues', icon: <CategoryIcon />, path: '/admin/catalogue-management', permission: 'catalogues.read' },
      { text: 'Stock Levels', icon: <WarehouseIcon />, path: '/admin/inventory-management?tab=stock', permission: 'inventory.read' },
      { text: 'Bulk Adjust', icon: <EditIcon />, path: '/admin/inventory-management?tab=bulk', permission: 'inventory.write' },
      { text: 'Movements', icon: <HistoryIcon />, path: '/admin/inventory-management?tab=movements', permission: 'inventory.read' },
      { text: 'Adj. Log', icon: <AssessmentIcon />, path: '/admin/inventory-management?tab=adjustments', permission: 'inventory.read' },
    ],
  },

  // ========== REMARKETING SECTION ==========
  {
    text: 'remarketing-separator',
    icon: <></>,
    separator: true,
  },
  {
    text: 'REMARKETING',
    icon: <></>,
    sectionLabel: true,
  },

  // ========== LEAD MANAGEMENT ==========
  {
    text: 'Leads',
    icon: <ContactsIcon />,
    permission: 'leads.read',
    children: [
      { text: 'All Leads', icon: <ListIcon />, path: '/admin/leads', permission: 'leads.read' },
      { text: 'Import Leads', icon: <UploadIcon />, path: '/admin/leads/import', permission: 'leads.write' },
      { text: 'Segments', icon: <FilterListIcon />, path: '/admin/leads/segments', permission: 'leads.read' },
      { text: 'Remarketing & Follow-ups', icon: <CampaignIcon />, path: '/admin/remarketing', permission: 'leads.read' },
      { text: 'WhatsApp Delivery & Queues', icon: <HubIcon />, path: '/admin/remarketing/delivery', permission: 'leads.read' },
    ],
  },

  // ========== PROMOTIONS ==========
  {
    text: 'Promotions',
    icon: <LocalOfferIcon />,
    permission: 'promotions.read',
    children: [
      { text: 'Clearance Sale', icon: <SellIcon />, path: '/admin/promotions/clearance', permission: 'promotions.read' },
      { text: 'Deals & Schemes', icon: <RedeemIcon />, path: '/admin/promotions/deals', permission: 'promotions.read' },
      { text: 'Influencer Trials', icon: <InstagramIcon />, path: '/admin/promotions/influencers', permission: 'influencer.read' },
    ],
  },

  // ========== ANALYTICS & REPORTS ==========
  {
    text: 'Analytics',
    icon: <AnalyticsIcon />,
    permission: 'reports.sales',
    children: [
      { text: 'Sales Analytics', icon: <SellIcon />, path: '/admin/sales/dashboard', permission: 'reports.sales' },
      { text: 'Customer Analytics', icon: <PartyIcon />, path: '/admin/analytics/customers', permission: 'reports.customers' },
      { text: 'Customer Behavior', icon: <VisibilityIcon />, path: '/admin/analytics/behavior', permission: 'analytics.behavior.read' },
      { text: 'Active Carts', icon: <ShoppingCartIcon />, path: '/admin/carts/active', permission: 'sales.carts.read' },
      { text: 'Custom Reports', icon: <AssessmentIcon />, path: '/admin/reports/custom', permission: 'reports.sales' },
      { text: 'Audit Logs', icon: <HistoryIcon />, path: '/analytics/audit-logs', permission: 'admin.audit.read' },
    ],
  },

  // ========== MASTER DATA & CONFIGURATION ==========
  {
    text: 'master-settings-separator',
    icon: <></>,
    separator: true,
  },
  {
    text: 'MASTER DATA & CONFIGURATION',
    icon: <></>,
    sectionLabel: true,
  },
  {
    text: 'Master Data & Settings',
    icon: <SettingsIcon />,
    requiredPermissions: ['admin.system.config'],
    children: [
      { text: 'Company Profile & Brand Master', icon: <CompanyIcon />, path: '/admin/configuration/company-profile', permission: 'admin.system.config' },
      { text: 'Warehouses', icon: <WarehouseIcon />, path: '/admin/configuration/warehouses', permission: 'admin.system.config' },
    ],
  },

  // ========== ACCESS CONTROL ==========
  {
    text: 'Access Control',
    icon: <SecurityIcon />,
    requiredPermissions: ['admin.users.read', 'admin.roles.read'],
    children: [
      { text: 'Users', icon: <PeopleIcon />, path: '/admin/users', permission: 'admin.users.read' },
      { text: 'Roles & Permissions', icon: <PartyIcon />, path: '/admin/roles', permission: 'admin.roles.read' },
    ],
  },

  // ========== INTEGRATIONS & IT ==========
  {
    text: 'Integrations & IT',
    icon: <IntegrationIcon />,
    requiredPermissions: ['integrations.read', 'admin.system.health'],
    children: [
      { text: 'Integrations Hub', icon: <HubIcon />, path: '/admin/integrations/config', permission: 'integrations.read' },
      { text: 'SMS & DLT Gateway', icon: <SmsIcon />, path: '/admin/integrations/sms', permission: 'integrations.read' },
      { text: 'IT Dashboard', icon: <WebhookIcon />, path: '/admin/it/dashboard', permission: 'admin.system.health' },
      { text: 'Integration Monitor', icon: <AssessmentIcon />, path: '/admin/integrations/health', permission: 'integrations.read' },
      { text: 'API Keys', icon: <ApiKeyIcon />, path: '/admin/integrations/api-keys', permission: 'settings.manage' },
    ],
  },

  // ========== FOOTER: LINKS & DOCS ==========
  {
    text: 'links-separator',
    icon: <></>,
    separator: true,
    footer: true,
  },
  {
    text: 'LINKS & DOCS',
    icon: <></>,
    sectionLabel: true,
    footer: true,
  },
  {
    text: 'API Documentation',
    icon: <ApiDocsIcon />,
    path: `${import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000'}/docs`,
    external: true,
    footer: true,
  },
  {
    text: 'API Reference',
    icon: <AssessmentIcon />,
    path: `${import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000'}/redoc`,
    external: true,
    footer: true,
  },
  {
    text: 'Customer Portal',
    icon: <CustomerPortalIcon />,
    path: import.meta.env.VITE_CUSTOMER_PORTAL_URL || '',
    external: true,
    footer: true,
  },
]

// getRolePermissions function removed. System now uses dynamic backend-driven RBAC.
